import React from 'react';
import { useTheme } from 'styled-components';
import { StyledSVG } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Icon = ({ size, name, className, margin, ...rest }) => {
    const theme = useTheme();
    const cleanedBasePath = theme.iconBasePath?.replace(/\/$/, '');
    const url = `${cleanedBasePath}/${name}-${size}.svg#main`;
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const sizeMap = {
        xs: '16px',
        s: '24px',
        l: '48px'
    };
    return (React.createElement(StyledSVG, { fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true, width: sizeMap[size], height: sizeMap[size], className: className, margin: margin, ...a11yProps, ...dataProps },
        React.createElement("use", { href: url })));
};
//# sourceMappingURL=index.js.map